/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/collapsible/custom-elements';

import { defineCustomElement as defineOsdsCollapsible } from '@ovhcloud/ods-stencil/components/collapsible/custom-elements/osds-collapsible.js';

export const OsdsCollapsible = /*@__PURE__*/createReactComponent<JSX.OsdsCollapsible, HTMLOsdsCollapsibleElement>('osds-collapsible', undefined, undefined, defineOsdsCollapsible);
